import React from 'react';
import { ArticleListItem } from './article-listing-item';
import { IArticleItem } from '../interfaces/types';
import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query/fetchBaseQuery';
import { SerializedError } from '@reduxjs/toolkit';
interface IArticleListProps {
    articles: IArticleItem[];
}

export const ArticleList: React.FC<IArticleListProps> = ({ articles, isLoading, hasError }) => {
    return (
        articles.length > 0 ?
            <ul className="grid grid-eq-4 article-listing-grid">
                {articles?.map((article, index) => (
                    <li key={index}>
                        <ArticleListItem article={article} />
                    </li>
                ))}
            </ul> : null
    )
}